exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kayenta .titled-section {\n  margin-bottom: 1em;\n}\n.kayenta .titled-section .contents {\n  margin: 10px 10px 0 10px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-cirrus);\n  padding: 15px;\n}\n.kayenta .titled-section .contents .list-group {\n  margin-bottom: 5px;\n}\n", ""]);

